import BusEvent from "common/services/BusEvent"
import AmountTaskIndicator from "./indicators/amountTaskIndicator"
import AmountInvoiceIndicator from "./indicators/amountInvoiceIndicator"
import AmountTicketIndicator from "./indicators/amountTicketIndicator"
import ClientsTypeIndicator from "./indicators/clientsTypeIndicator"
import NumberTaskIndicator from "./indicators/numberTaskIndicator"

export default function subscribeEvents() {
    BusEvent.subscribe(BusEvent.NEW_TASK, (task) => {
        ClientsTypeIndicator.newTask(task)
        NumberTaskIndicator.addTask({ task })
        AmountTaskIndicator.addTask(task)
    })

    BusEvent.subscribe(BusEvent.UPDATE_TASK, ({ task, oldTask }) => {
        AmountTaskIndicator.updateTask({ task, oldTask })
        NumberTaskIndicator.updateTask({ task, oldTask })
    })

    BusEvent.subscribe(BusEvent.DELETE_TASK, (task) => {
        AmountTaskIndicator.deleteTask(task)
        NumberTaskIndicator.deleteTask({ task })
    })

    BusEvent.subscribe(BusEvent.NEW_INVOICE, (invoice) => {
        
    })

    BusEvent.subscribe(BusEvent.UPDATE_INVOICE, ({ invoice, oldInvoice }) => {
        AmountInvoiceIndicator.updateInvoice(invoice, oldInvoice)
    })

    BusEvent.subscribe(BusEvent.DELETE_INVOICE, (invoice) => {
        AmountInvoiceIndicator.deleteInvoice(invoice)
    })

    BusEvent.subscribe(BusEvent.NEW_TICKET, (ticket) => {
        
    })

    BusEvent.subscribe(BusEvent.UPDATE_TICKET, ({ ticket, oldTicket }) => {
        AmountTicketIndicator.updateTicket(ticket, oldTicket)
    })

    BusEvent.subscribe(BusEvent.DELETE_TICKET, (ticket) => {
        AmountTicketIndicator.deleteTicket(ticket)
    })
}